export const fonts = {
  prodisplay: '"ProDisplay", sans-serif',
  protext: '"ProText", sans-serif',
  arial: '"Arial", sans-serif'
};
